<mat-toolbar>
  <a routerLink="/" aria-label="Home">
    <img class="logo" src="assets/images/logo.svg" alt="Company Logo" />
  </a>
  <span class="spacer"></span>
  <a
    *ngIf="showFormerTeamButton"
    href="https://teamspace.woolworths.com.au/external-queries"
    target="_blank"
    color="accent"
    class="roundedButton"
    mat-raised-button
    aria-label="Former Team"
  >
    <mat-icon iconPositionEnd>chevron_right</mat-icon>
    Former Team
  </a>
  <button
    *ngIf="showLogoutButton && isLoggedIn()"
    color="accent"
    class="roundedButton"
    mat-raised-button
    aria-label="Logout"
    (click)="logout()"
  >
    <mat-icon iconPositionEnd>logout</mat-icon>
    Logout
  </button>
</mat-toolbar>
